// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type OfferContextProperties = {
  class_type?: string;
  fare_type: string;
  seat_preference?: string;
  arrival_position_id?: number;
  company: string;
  price_euro_cents?: number;
  provider: string;
  departure_position_id?: number;
  return_offer_index?: number;
  baggage_price?: number;
  is_onsite?: boolean;
  baggage_count?: number;
  currency?: string;
  segments_array?: string;
  return_price_in_cents?: number;
  return_class_type?: string;
  price_in_cents?: number;
  return_is_onsite?: boolean;
  return_company?: string;
  travel_mode: string;
  offer_index: number;
  return_provider?: string;
  tickets_left?: number;
  return_fare_type?: string;
  is_mobile_ticket?: boolean;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/offer_context/jsonschema/5-0-3';
export const offerContextName = 'offer_context';
export class OfferContext extends BaseTrackingContext<OfferContextProperties> {
  constructor(properties: OfferContextProperties) {
    super(offerContextName, schema, properties);
  }
}
